// extracted by mini-css-extract-plugin
module.exports = {"formControl":"FormControl_formControl__UEzNv","input":"FormControl_input__1bjwB","attention":"FormControl_attention__2-YKF","wrong":"FormControl_wrong__3z8oh"};